module.exports = __webpack_public_path__ + "static/media/3d-plan_general SureSmile.e3c5e8be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/3d-plan_general SureSmile.svg
// module id = 1037
// module chunks = 0